import {Organization} from "./organization/hds/Organization";
import {HospitalPatientFile} from "./hospital/HospitalPatientFile";
import {HospitalUser} from "./User";
import {HospitalUnit} from "@/core/interfaces/hospital/Hospital";
import Consumer from "@/core/interfaces/consumers/Consumer";

export interface Sharing {
    /** The sharing id. */
    id: number;
    /** The tenant. */
    tenant: HospitalUnit;
    /** The tenant type. */
    tenant_type: TenantType;
    /** The tenant name. */
    tenant_name: string;
    /** The sharable. */
    sharable: Consumer;
    /** The sharable type. */
    sharable_type: "customer" | "beneficiary" | "hospital-patient";
    /** The owner type. */
    owner_type: "organization";
    /** The owner. */
    owner: Organization;
    /** The applicant user. */
    applicant: SharingApplicant;
    /** The date of the authorization. */
    authorized_at?: string;
    /** The date of the sharing request. */
    created_at: string;
    /** The date of the sharing decline. */
    declined_at?: string;
    /** The hospital patient files linked to the sharing. */
    hospital_patient_files: HospitalPatientFile[];
    /** The status of the sharing. */
    status: SharingStatus;
}

/**
 * The sharing applicant type.
 */
export type SharingApplicant = HospitalUser;

export enum TenantType {
    HOSPITAL_UNIT = "unit"
}

export enum SharingStatus {
    AUTHORIZED = "authorized",
    DECLINED = "declined",
    PENDING = "pending",
}
